
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  //   FormControl,
  ListItem,
  ListItemText,
  List,
  Select,
  MenuItem,
  SelectChangeEvent,
  Stack,
  Checkbox,
  Link,
  // FormControlLabel,
} from "@mui/material";
// import contactus from "../../assets/images/landingpage/Contact Us.webp";
import pattern from "../../assets/images/landingpage/background.webp";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useTranslation } from "react-i18next";
import intlTelInput from "intl-tel-input";
import "../../styles/freetrail.scss";
import { toast } from "react-toastify";
import axios, { AxiosError } from "axios";
import { axiosInstance } from "../../utils/tokenSetCookie";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import TermsandConditions from "../../userAuth/Login/termsandconditions";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
// import { useGoogleAnalytics } from "../../hooks/useGoogleAnalaytics";
// import Ent_Video from "/assets/landing-page/videos/ENT_DEMO.mp4"
// import Video1 from "/assets/landing-page/videos/freetrial_page_video1.mp4"
// import Video2 from "/assets/landing-page/videos/freetrial_page_video2.mp4"

const Video1 = "https://cdn.clinicalvisuals.com/siteImages/freetrial_page_video1.mp4"
const Video2 = "https://cdn.clinicalvisuals.com/siteImages/freetrial_page_video2.mp4"


const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const API_VITE_SANDBOX_PRICE_ID = import.meta.env.VITE_SANDBOX_PRICE_ID;
const API_VITE_CHECKOUT = import.meta.env.VITE_CHECKOUT;
const API_VITE_TRIAL_DAYS = import.meta.env.VITE_TRIAL_DAYS;
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
const VITE_ENT_SUBSCRIPTION_AMOUNT = import.meta.env.VITE_ENT_SUBSCRIPTION_AMOUNT;

//  const IP_ADDRESS = "123.45.67.89";


// Interface for form data
interface FormData {
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  countryCode: string;
  phoneNumber: string;
}

// Interface for business info
interface BusinessInfo {
  businessName: string;
  emailId: string;
  businessPhone: string;
  address: string;
  city: string;
  stateProvince: string;
  country: string;
  countryFlag: string;
  countryCode: string;
  zipCode: string;
  noOfLocations: string;
}

const Signup: React.FC = () => {
  // const [analyticStarted, setAnalyticStarted] = useState(false)
  const { t } = useTranslation();
  const [sessionId, setSessionId] = useState("")
  const [paymentMethod, setPaymentMethod] = useState("free");
  // const [submitBtnStatus, setSubmitBtnStatus] = useState(true);
  const [successOpen, setSuccessOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [modalType, setModalType] = useState<"terms" | "privacy">("terms");
  const [modalTitle, setModalTitle] = useState("");
  const [openterms, setOpenterms] = useState(false);
  const [isMobileChecked, setIsMobileChecked] = useState(false);
  const hostname = window.location.hostname; // e.g., "ent.clinicalvisuals.com"
  const parts = hostname.split(".");
  // console.log("parts", parts);

  // Handles cases like ent.clinicalvisuals.com, dev.ent.clinicalvisuals.com
  const subdomain = parts.length > 1 ? parts[0] : null;
  // console.log("subdomain", subdomain);

  const subscriptionAmount =
    subdomain === "ent" ? VITE_ENT_SUBSCRIPTION_AMOUNT : 50; const [submitPersonalInformation, setSubmitPersonalInformation] = useState(false)


  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    country: "us",
    countryCode: "+1",
    phoneNumber: "",
  });

  const [formErrors, setFormErrors] = useState<FormData>({
    firstName: "",
    lastName: "",
    email: "",
    country: "",
    countryCode: "",
    phoneNumber: "",
  });
  const [businessInfo, setBusinessInfo] = useState<BusinessInfo>({
    businessName: "",
    emailId: "",
    businessPhone: "",
    address: "",
    city: "",
    stateProvince: "",
    country: "",
    countryFlag: "us",
    countryCode: "+1",
    zipCode: "",
    noOfLocations: "1",
  });

  const [businessFormErrors, setBusinessFormErrors] = useState<BusinessInfo>({
    businessName: "",
    emailId: "",
    businessPhone: "",
    address: "",
    city: "",
    stateProvince: "",
    country: "",
    countryFlag: "us",
    countryCode: "+1",
    zipCode: "",
    noOfLocations: "1",
  });

  const emptyFormData = {
    firstName: "",
    lastName: "",
    email: "",
    country: "us",
    countryCode: "+1",
    phoneNumber: "",
  };
  const emptyBusinessInfo = {
    businessName: "",
    emailId: "",
    businessPhone: "",
    address: "",
    city: "",
    stateProvince: "",
    country: "",
    countryFlag: "us",
    countryCode: "",
    zipCode: "",
    noOfLocations: "1",
  };

  // Function to handle form input changes
  const handleInputChange = (e: { target: { name: any; value: any } }) => {

    // if (!analyticStarted) {
    //   setAnalyticStarted(true);
    //   handleFormStart();
    // }
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (isMobileChecked) {
      if (name === "countryCode") {
        setBusinessInfo((prev: BusinessInfo) => ({
          ...prev,
          countryCode: value,
        }));
      }
      if (name === "phoneNumber") {
        setBusinessInfo((prev: BusinessInfo) => ({
          ...prev,
          businessPhone: value,
        }));
      }
      if (name === "email") {
        setBusinessInfo((prev: BusinessInfo) => ({
          ...prev,
          emailId: value,
        }));
      }
    }


    // Clear error when user starts typing
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  // Function to handle business info changes
  const handleBusinessInfoChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    // if (!analyticStarted) {
    //   setAnalyticStarted(true);
    //   handleBusinessFormStart();
    // }
    const { name, value } = e.target;
    setBusinessInfo((prev: BusinessInfo) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error message when the user starts typing a valid value
    setBusinessFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Reset error if corrected
    }));
  };

  // Function to handle business info select
  const handleBusinessInfoSelect = (
    e: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<string>
  ) => {
    const { name, value } = e.target;
    setBusinessInfo((prev: BusinessInfo) => ({
      ...prev,
      [name]: value,
    }));
  };
  const allowOnlyNumbers = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];

    if (!/^[0-9]$/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasteData = e.clipboardData.getData("text");
    if (!/^\d+$/.test(pasteData)) {
      e.preventDefault(); // Block if pasted content is not all digits
    }
  };

  const countryData = intlTelInput.getCountryData();
  const countryOptions = countryData
    .filter(
      (country) =>
        !(country.dialCode === "1" && country.iso2 !== "us") &&
        !(country.dialCode === "44" && country.iso2 !== "gb")
    )
    .map((country) => ({
      code: `+${country.dialCode}`,
      flag: country.iso2,
      name: country.name,
    }));

  // Function to fetch country code on component mount
  useEffect(() => {
    if (!localStorage.getItem("countryCode")) {
      const fetchCountryCode = async () => {
        try {
          const response = await axios.get("https://ipapi.co/json/");
          const res = response.data.country_calling_code;
          localStorage.setItem("countryCode", res);
          const countryCode = localStorage.getItem("countryCode");
          const country = countryOptions.find(
            (option) => option.code === countryCode
          );
          if (country) {
            setFormData((prevData) => ({
              ...prevData,
              country: country.flag,
            }));
            setFormData((prevData) => ({
              ...prevData,
              countryCode: country.code,
            }));
            setBusinessInfo((prevData) => ({
              ...prevData,
              countryFlag: country.flag,
            }));
            setBusinessInfo((prevData) => ({
              ...prevData,
              countryCode: country.code,
            }));
          }
        } catch (error) {
          console.error("Error fetching country code:", error);
        }
      };
      fetchCountryCode();
    }
  }, []);

  // Function to validate form
  const validateForm = () => {
    let valid = true;
    const newErrors: FormData = { ...formErrors }; // Now TypeScript knows it's the correct type

    // Validate first name
    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
      valid = false;
    }
    // Validate last name
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
      valid = false;
    }
    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      valid = false;
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
      valid = false;
    }
    // Validate phone number
    const phoneRegex = /^[0-9]{7,15}$/;
    if (formData.phoneNumber.length !== 0) {
      if (!phoneRegex.test(formData.phoneNumber)) {
        newErrors.phoneNumber = "Phone number must be 7-15 digits";
        valid = false;
      }
    }

    setFormErrors(newErrors);
    return valid;
  };
  // Function to validate business form
  const validateBusinessForm = () => {
    let valid = true;
    const newErrors = { ...businessFormErrors };

    // Validate Business name
    if (!businessInfo.businessName.trim()) {
      newErrors.businessName = "Business name is required";
      valid = false;
    }
    // Validate address
    if (!businessInfo.address.trim()) {
      newErrors.address = "Business address is required";
      valid = false;
    }
    // Validate state
    if (!businessInfo.stateProvince.trim()) {
      newErrors.stateProvince = "Business phone is required";
      valid = false;
    }
    // Validate last name
    if (!businessInfo.country.trim()) {
      newErrors.country = "Country is required";
      valid = false;
    }
    // Validate last name
    if (!businessInfo.zipCode.trim()) {
      newErrors.zipCode = "Zipcode is required";
      valid = false;
    }
    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!businessInfo.emailId.trim()) {
      newErrors.emailId = "Email is required";
      valid = false;
    } else if (!emailRegex.test(businessInfo.emailId)) {
      newErrors.emailId = "Invalid email format";
      valid = false;
    }
    // Validate phone number
    const phoneRegex = /^[0-9]{7,15}$/;
    if (!businessInfo.businessPhone.trim()) {
      newErrors.businessPhone = "Phone number is required";
      valid = false;
    } else if (!phoneRegex.test(businessInfo.businessPhone)) {
      newErrors.businessPhone = "Phone number must be 7-15 digits";
      valid = false;
    }
    setBusinessFormErrors(newErrors);
    return valid;
  };


  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
  };


  // Function to handle mobile checkbox change
  const handleEmailMobileCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsMobileChecked(event.target.checked);
    if (event.target.checked) {
      setBusinessInfo((prevData) => ({
        ...prevData,
        businessPhone: formData.phoneNumber,
        countryCode: formData.countryCode,
        emailId: formData.email,
      }));
    } else {
      setBusinessInfo((prevData) => ({
        ...prevData,
        businessPhone: "",
        countryCode: "+1",
        emailId: "",
      }))
    }
  };
  // const allFieldsValid = () => {
  //   const isFormDataValid = Object.values(formData).every(
  //     (value) => value.length > 0
  //   );
  //   const isBusinessInfoValid = Object.values(businessInfo).every(
  //     (value) => value.length > 0
  //   );

  //   return isFormDataValid && isBusinessInfoValid && isChecked;
  // };

  // const canProceed = allFieldsValid();

  // Function to handle business form submit


  const handleSubmit = async () => {

    window.gtag("event", "business_form_submit", {
      page_path: window.location.pathname,
      form_type: "business_information",
      environment: process.env.NODE_ENV,
    })
    // if (!validateForm()) return; // Ensure validation returns a boolean
    if (!validateBusinessForm()) return; // Ensure validation returns a boolean
    const payload = {
      priceId: API_VITE_SANDBOX_PRICE_ID,
      sessionId: sessionId,
      firstName: formData.firstName,
      lastName: formData.lastName,
      phoneNumber:
        "+" + Number(`${formData.countryCode}${formData.phoneNumber}`),
      emailId: formData.email,
      businessName: businessInfo.businessName,
      businessEmailId: businessInfo.emailId,
      businessPhone:
        "+" + Number(businessInfo.countryCode) + businessInfo.businessPhone,
      businessAddress: businessInfo.address,
      businessCity: businessInfo.city,
      businessState: businessInfo.stateProvince,
      businessCountry: businessInfo.country,
      businessZipcode: businessInfo.zipCode,
      businessLocationCount: Number(businessInfo.noOfLocations),
      businessUserCount: 1,
      webSiteId: 1,
      trialDays: Number(API_VITE_TRIAL_DAYS),
    };

    //Testing Purpose
    // setAnalyticStarted(false)
    // handleBusinessFormSubmit(true)


    try {
      const response = await axiosInstance.post(
        API_BASE_URL + "payment/create-free-trial-step2",
        payload
      );
      if (response.status >= 200 && response.status <= 300) {
        // setAnalyticStarted(false)
        handleBusinessFormSubmit(true)
        handleStripe()
        if (API_VITE_CHECKOUT === "0") {
          setSuccessOpen(true);
        } else {
          // setSubmitBtnStatus(true);
          setTimeout(() => {
            window.location.href = response.data.data.url;
          });

        }
      }
    } catch (error) {
      handleBusinessFormSubmit(false)
      const err = error as AxiosError<{ message: string }>;
      toast.error(err.response?.data?.message || "Something went wrong", {
        autoClose: 1000,
      });
    }
    // }
  };

  // Function to handle success modal close
  const handleSuccessClose = () => {
    setSuccessOpen(false);
    // Reset fields after submission
    setFormData(emptyFormData);
    setBusinessInfo(emptyBusinessInfo);
  };

  const handleopenterms = (type: "terms" | "privacy") => {
    setModalType(type);
    setModalTitle(
      type === "terms" ? t("terms_conditions") : t("privacy_policy")
    );
    setOpenterms(true);
  };

  const handlecloseterms = () => {
    setOpenterms(false);
  };


  const handlePersonalInformation = async () => {

    window.gtag("event", "personal_form_submit", {
      page_path: window.location.pathname,
      form_type: "personal_information",
      environment: process.env.NODE_ENV,
    })
    console.log("personal submit button clicked event sent!");

    if (!validateForm()) return;

    let ip = "";
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      console.log("IP Address:", data.ip);
      ip = data.ip;
    } catch (error) {
      console.error("Error fetching IP address:", error);
      toast.error("Error Fetching IP");
    }
    // ReactGA.event({
    //   category: "Submit Button",
    //   action: "Personal Information Submit Button Clicked",
    //   label: "Free Trial Section",
    // });

    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      phoneNumber:
        "+" + Number(`${formData.countryCode}${formData.phoneNumber}`),
      emailId: formData.email,
      ipAddress: ip
    };
    // For Testing Purpose
    // setAnalyticStarted(false)
    // handleFormSubmit(true)
    // setSubmitPersonalInformation(prev => !prev)


    try {
      const response = await axiosInstance.post(
        API_BASE_URL + "payment/create-free-trial-step1",
        payload
      );
      if (response.status >= 200 && response.status <= 300) {
        // setAnalyticStarted(false)
        handleFormSubmit(true)
        console.log(response.data.data)
        const sessionID = response.data.data.sessionId
        setSessionId(sessionID)
        setSubmitPersonalInformation(prev => !prev)
      }
    } catch (error) {
      handleFormSubmit(false)
      const err = error as AxiosError<{ message: string }>;
      toast.error(err.response?.data?.message || "Something went wrong", {
        autoClose: 1000,
      });
    }
  }

  // const handleFormStart = () => {
  //   if (typeof window.gtag === "function") {
  //     window.gtag("event", "personal_form_start", {
  //       page_path: window.location.pathname,
  //       form_type: "personal_information",
  //       environment: process.env.NODE_ENV,
  //     })
  //   }
  // }

  const handleFormSubmit = (isSuccess: boolean) => {
    if (typeof window.gtag === "function") {
      window.gtag("event", isSuccess ? "personal_form_success" : "personal_form_error", {
        page_path: window.location.pathname,
        form_type: "personal_information",
        environment: process.env.NODE_ENV,
      })
    }
  }

  // const handleBusinessFormStart = () => {
  //   if (typeof window.gtag === "function") {
  //     window.gtag("event", "business_form_start", {
  //       page_path: window.location.pathname,
  //       form_type: "business_information",
  //       environment: process.env.NODE_ENV,
  //     })
  //   }
  // }


  const handleBusinessFormSubmit = (isSuccess: boolean) => {
    if (typeof window.gtag === "function") {
      window.gtag("event", isSuccess ? "business_form_sucess" : "business_form_error", {
        page_path: window.location.pathname,
        form_type: "business_information",
        environment: process.env.NODE_ENV,
      })
    }
  }

 const handleStripe = () => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "stripe_page_view", {
        page_path: window.location.pathname,
        form_type: "stripe checkout",
        environment: process.env.NODE_ENV,
      })
    }
  }


  console.log(sessionId)
  return (
    <>
      <Box
        display="flex"
        minHeight={{ lg: "100%", md: "100%", sm: "100%", xs: "100%" }}
        width="100vw"
        sx={{ backgroundColor: "#fff" }}
      >
        <Grid
          container
          sx={{
            display: "flex",
            width: "100%",
            height: "100vh",
            minHeight: { lg: "100%", md: "100%", sm: "100%", xs: "100%" },
            // overflow: "auto",
            maxWidth: "100%",
            boxShadow: 3,
            transition: "all 0.5s ease",
          }}
          className="freeTrial"
        >
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              padding: {
                lg: "0px !important",
                md: "0px !important",
                sm: "0px !important",
                xs: "0px !important",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                backgroundImage: `url(${pattern})`,
                backgroundSize: "contain",
                backgroundColor: "#1976d2",
                padding: { xs: "20px", sm: "10px", md: "30px" },
              }}
            >
              <Box
                sx={{
                  borderRadius: "12px",
                  overflow: "auto",
                  height: "100%",
                  display: "contents",
                }}
              >
                <Typography
                  className="heading"
                  variant="h4"
                  sx={{
                    color: "#fff",
                    fontWeight: "bold",
                    textAlign: "left",
                    fontSize: "2.5rem",
                    mb: { lg: 1, md: 2, sm: 1, xs: 1 },
                  }}
                >
                  {t("jump_in_free_access")}
                </Typography>
                <Typography
                  className="trailtitle"
                  variant="h6"
                  color="#fff"
                  fontWeight="bold"
                  gutterBottom
                  sx={{ mt: 2, mb: 1 }}
                >
                  {t("free_trial_transform_your_communication")}
                </Typography>

                <Typography
                  className="trailbody"
                  variant="body1"
                  color="text.secondary"
                  sx={{ mb: 2, color: "#eee" }}
                >
                  {t("free_trial_enjoy_free_access")}
                </Typography>
                <Typography
                  className="trailtitle start_free"
                  variant="h6"
                  color="#fff"
                  fontWeight="bold"
                  alignItems={"center"}
                  paddingTop={{ lg: 1, md: 3, sm: 1, xs: 1 }}
                  gutterBottom
                >
                  {t("start_your_free_trial_now")}
                </Typography>
                {/* <Box
                  className="freetrialimg"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: `url(${""})`,
                    width: "50%",
                    height: "35%",
                    borderRadius: "12px",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    margin: "0 auto",
                    cursor: "pointer",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                    },
                  }}
                ></Box> */}
                <Box
                  sx={{
                    width: { xs: "100%", sm: "100%", md: "95%" },
                    height: "auto",
                    overflow: "hidden",
                    borderRadius: 2,
                    my: "20px",
                  }}
                >
                  <video
                    src={submitPersonalInformation ? Video2 : Video1}
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                      // backgroundSize: "cover",
                      pointerEvents: "none", // Optional: disable interaction
                    }}
                  />
                </Box>

                <Paper
                  elevation={paymentMethod === "free" ? 1 : 1}
                  sx={{
                    p: 1,
                    mt: 2,
                    width: { xs: "100%", sm: "100%", md: "95%" },
                    borderRadius: "12px",
                    backgroundColor:
                      paymentMethod === "free" ? "transparent" : "#1976d2",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                    },
                  }}
                  onClick={() => setPaymentMethod("free")}
                >
                  <Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    ></Box>
                    <Typography
                      variant="body2"
                      color={
                        paymentMethod === "free" ? "white" : "text.secondary"
                      }
                    >
                      <List className="freeTrialList">
                        {[
                          {
                            text: "free_trial_30days_free_access",
                          },
                          {
                            text: "free_trial_view_share",
                          },
                          {
                            text: "free_trial_conclution",
                          },
                          {
                            text: "free_trial_cancel_anytime",
                          },
                        ].map((item) => (
                          <ListItem
                            className="listItemText"
                            key={item.text}
                            sx={{
                              py: 0.1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {/* Small circle icon */}
                            <Box display="flex">
                              <FiberManualRecordIcon
                                sx={{
                                  fontSize: 8,
                                  color: "white",
                                  mr: 1,
                                  mt: "10px", // Adjusts vertical alignment
                                }}
                              />
                              <ListItemText
                                className="text"
                                primary={
                                  item.text === "free_trial_conclution"
                                    ? `${t(item.text) + " $" + subscriptionAmount}.`
                                    : `${t(item.text)}`
                                }
                                primaryTypographyProps={{
                                  color: "white",
                                  fontWeight: "bold",
                                }}
                              />
                            </Box>
                          </ListItem>
                        ))}
                      </List>
                    </Typography>
                  </Box>
                </Paper>

                <Typography
                  className="note"
                  variant="body1"
                  fontWeight="bold"
                  color="#fff"
                  textAlign={"justify"}
                  fontSize={"14px"}
                  sx={{ mt: 2, mb: 2 }}
                >
                  {t("free_trial_note")}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              padding: {
                lg: "0px !important",
                md: "0px !important",
                sm: "0px !important",
                xs: "10px !important",
              },
            }}
          >
            <Box
              className="right_sec"
              sx={{
                width: { xs: "100%", md: "100%" },
                height: "100%",
                p: { xs: 4, md: 5 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                backgroundColor: "#fff",
              }}
            >
              <Box
                component="form"
                className="form"
                sx={{
                  fontSize: "12px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  mb={6}
                  sx={{
                    position: "absolute",
                    top: 20,
                    right: 20,
                    display: { xs: "none", md: "block" },
                  }}
                >
                  <Box
                    component="img"
                    src={`${VISUALIZE__URL}Clinical_Visuals_Logo.webp`}
                    alt="Logo"
                    sx={{
                      width: { xs: 150, sm: 150, md: 150, lg: 250 },
                      height: "auto",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate("/");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  />
                </Box>
                {/* Personal Information Form */}

                {!submitPersonalInformation && (
                  <Box
                    sx={{
                      fontSize: "12px",
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      mt: { xs: "50px", md: "-150px" },
                      // pointerEvents: submitPersonalInformation ? "none" : "auto",
                      // opacity: submitPersonalInformation ? 0 : 1
                    }}
                  >
                    <Typography
                      className="heading"
                      variant="h5"
                      color="primary"
                      fontWeight="bold"
                      gutterBottom
                      sx={{
                        mb: 1,
                        // mt: 2,
                      }}
                    >
                      {t("personal_information")}
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <TextField
                        className="feild"
                        label={t("first_name")}
                        variant="outlined"
                        fullWidth
                        id="firstName"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        error={Boolean(formErrors.firstName)}
                        helperText={formErrors.firstName}
                        required
                        InputProps={{
                          sx: {
                            borderRadius: "8px",
                            height: "44px",
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#1976D2",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#1976D2",
                              borderWidth: "2px",
                            },
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: "14px",
                            lineHeight: "15px",
                          },
                        }}
                      />
                      <TextField
                        className="feild"
                        label={t("last_name")}
                        variant="outlined"
                        fullWidth
                        id="lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        error={Boolean(formErrors.lastName)}
                        helperText={formErrors.lastName}
                        required
                        InputProps={{
                          sx: {
                            borderRadius: "8px",
                            height: "44px",
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#1976D2",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#1976D2",
                              borderWidth: "2px",
                            },
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: "14px",
                            lineHeight: "15px",
                          },
                        }}
                      />
                    </Box>
                    <TextField
                      className="feild"
                      label={t("email_address")}
                      variant="outlined"
                      fullWidth
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      error={Boolean(formErrors.email)}
                      helperText={formErrors.email}
                      required
                      InputProps={{
                        sx: {
                          borderRadius: "8px",
                          height: "44px",
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1976D2",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1976D2",
                            borderWidth: "2px",
                          },
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontSize: "14px",
                          lineHeight: "15px",
                        },
                      }}
                    />
                    <Box className="feild" sx={{ display: "flex", gap: 1 }}>
                      <Select
                        name="countryCode"
                        value={formData.countryCode}
                        onChange={handleInputChange}
                        displayEmpty
                        required
                        renderValue={(selected) => {
                          const selectedCountry = countryOptions.find(
                            (option) => option.code === selected
                          );
                          return selectedCountry ? (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                src={`https://flagcdn.com/16x12/${selectedCountry.flag}.png`}
                                alt={selectedCountry.flag}
                                style={{
                                  width: 30,
                                  height: 22,
                                  marginRight: 5,
                                }}
                              />
                              <span style={{ fontSize: "12px" }}>
                                {selectedCountry.code}
                              </span>
                            </div>
                          ) : null;
                        }}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          PaperProps: {
                            style: {
                              maxHeight: 200, // Decrease the height of the list view
                            },
                          },
                        }}
                        sx={{
                          width: "120px", // Reduce select field width
                          height: "45px", // Reduce select field height
                          fontSize: "12px", // Reduce text size
                          "& .MuiSelect-select": {
                            display: "flex",
                            alignItems: "center",
                            padding: "4px 8px",
                          },
                        }}
                      >
                        {countryOptions.map((option) => (
                          <MenuItem
                            sx={{
                              fontSize: "12px", // Small text size in dropdown
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              padding: "5px 10px", // Small padding for compact look
                            }}
                            key={option.code}
                            value={option.code}
                          >
                            <img
                              src={`https://flagcdn.com/16x12/${option.flag}.png`}
                              alt={`${option.name} flag`}
                              style={{ width: 16, height: 12 }}
                            />
                            {option.name} ({option.code})
                          </MenuItem>
                        ))}
                      </Select>

                      <TextField
                        className="feild"
                        label={t("phone_number")}
                        variant="outlined"
                        fullWidth
                        id="phoneNumber"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        onKeyPress={allowOnlyNumbers}
                        onPaste={handlePaste}
                        // error={Boolean(formErrors.phoneNumber)}
                        // helperText={formErrors.phoneNumber}
                        // required
                        InputProps={{
                          sx: {
                            borderRadius: "8px",
                            height: "44px",
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#1976D2",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#1976D2",
                              borderWidth: "2px",
                            },
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: "14px",
                            lineHeight: "15px",
                          },
                        }}
                      />
                    </Box>
                    <Stack direction="row" alignItems="center">
                      <Checkbox
                        required
                        checked={isMobileChecked}
                        onChange={handleEmailMobileCheckboxChange}
                        size="small"
                        sx={{ padding: 0, marginRight: "4px" }}
                      />
                      <Typography variant="caption" sx={{ lineHeight: 1.5 }}>
                        Use same contact details for Business.
                      </Typography>
                    </Stack>

                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          width: { xs: "100%", sm: "160px" },
                          borderRadius: "10px",
                          textTransform: "none",
                          py: 1.5,
                          fontSize: "1rem",
                          textAlign: "center",
                        }}
                        onClick={handlePersonalInformation}
                      >
                        Submit
                      </Button>
                    </Grid>
                  </Box>
                )}

                <hr className="hr-line" />

                {/* Business Information Form */}

                {submitPersonalInformation && (
                  <Box
                    sx={{
                      borderRadius: "12px",
                      height: "100%",
                      overflow: "auto",
                      // pointerEvents: submitPersonalInformation ? "auto" : "none",
                      // opacity: submitPersonalInformation ? 1 : 0
                    }}
                  >
                    <Typography
                      className="heading"
                      variant="h5"
                      color="primary"
                      fontWeight="bold"
                      gutterBottom
                    >
                      {t("business_information")}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 3 }}
                    >
                      {t("free_trial_select_business_details")}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      <Box sx={{ display: "flex", gap: 2 }}>
                        <TextField
                          label={t("business_name")}
                          variant="outlined"
                          fullWidth
                          name="businessName"
                          value={businessInfo.businessName}
                          onChange={handleBusinessInfoChange}
                          error={Boolean(businessFormErrors.businessName)}
                          helperText={businessFormErrors.businessName}
                          required
                          size="small"
                          InputProps={{
                            sx: {
                              borderRadius: "8px",
                              height: "44px",
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#1976D2",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "#1976D2",
                                borderWidth: "2px",
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: "14px",
                              lineHeight: "25px",
                            },
                          }}
                        />
                        <TextField
                          label={t("email_address")}
                          variant="outlined"
                          fullWidth
                          name="emailId"
                          value={businessInfo.emailId}
                          onChange={handleBusinessInfoChange}
                          error={Boolean(businessFormErrors.emailId)}
                          helperText={businessFormErrors.emailId}
                          required
                          size="small"
                          InputProps={{
                            sx: {
                              borderRadius: "8px",
                              height: "44px",
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#1976D2",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "#1976D2",
                                borderWidth: "2px",
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: "14px",
                              lineHeight: "25px",
                            },
                          }}
                        />
                      </Box>

                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Select
                          name="countryCode"
                          value={businessInfo.countryCode}
                          onChange={handleBusinessInfoSelect}
                          displayEmpty
                          required
                          renderValue={(selected) => {
                            const selectedCountry = countryOptions.find(
                              (option) => option.code === selected
                            );
                            return selectedCountry ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={`https://flagcdn.com/16x12/${selectedCountry.flag}.png`}
                                  alt={selectedCountry.flag}
                                  style={{
                                    width: 30,
                                    height: 22,
                                    marginRight: 5,
                                  }}
                                />
                                <span style={{ fontSize: "12px" }}>
                                  {selectedCountry.code}
                                </span>
                              </div>
                            ) : null;
                          }}
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                            PaperProps: {
                              style: {
                                maxHeight: 200, // Decrease the height of the list view
                              },
                            },
                          }}
                          sx={{
                            width: "120px", // Reduce select field width
                            height: "45px", // Reduce select field height
                            fontSize: "12px", // Reduce text size
                            "& .MuiSelect-select": {
                              display: "flex",
                              alignItems: "center",
                              padding: "4px 8px",
                            },
                          }}
                        >
                          {countryOptions.map((option) => (
                            <MenuItem
                              sx={{
                                fontSize: "12px", // Small text size in dropdown
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                padding: "5px 10px", // Small padding for compact look
                              }}
                              key={option.code}
                              value={option.code}
                            >
                              <img
                                src={`https://flagcdn.com/16x12/${option.flag}.png`}
                                alt={`${option.name} flag`}
                                style={{ width: 16, height: 12 }}
                              />
                              {option.name} ({option.code})
                            </MenuItem>
                          ))}
                        </Select>

                        <TextField
                          label={t("phone_number")}
                          variant="outlined"
                          fullWidth
                          id="contactInfo"
                          name="businessPhone"
                          value={businessInfo.businessPhone}
                          onChange={handleBusinessInfoChange}
                          onKeyPress={allowOnlyNumbers}
                          onPaste={handlePaste}
                          error={Boolean(businessFormErrors.businessPhone)}
                          helperText={businessFormErrors.businessPhone}
                          required
                          InputProps={{
                            sx: {
                              borderRadius: "8px",
                              height: "44px",
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#1976D2",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "#1976D2",
                                borderWidth: "2px",
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: "14px",
                              lineHeight: "10px",
                            },
                          }}
                        />
                      </Box>
                      <Box sx={{ display: "flex", gap: 2 }}>
                        <TextField
                          label={t("address")}
                          variant="outlined"
                          fullWidth
                          name="address"
                          value={businessInfo.address}
                          onChange={handleBusinessInfoChange}
                          error={Boolean(businessFormErrors.address)}
                          helperText={businessFormErrors.address}
                          required
                          size="small"
                          InputProps={{
                            sx: {
                              borderRadius: "8px",
                              height: "44px",
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#1976D2",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "#1976D2",
                                borderWidth: "2px",
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: "14px",
                              lineHeight: "25px",
                            },
                          }}
                        />
                        <TextField
                          label={t("city")}
                          variant="outlined"
                          fullWidth
                          name="city"
                          value={businessInfo.city}
                          onChange={handleBusinessInfoChange}
                          error={Boolean(businessFormErrors.city)}
                          helperText={businessFormErrors.city}
                          required
                          size="small"
                          InputProps={{
                            sx: {
                              borderRadius: "8px",
                              height: "44px",
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#1976D2",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "#1976D2",
                                borderWidth: "2px",
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: "14px",
                              lineHeight: "25px",
                            },
                          }}
                        />
                      </Box>

                      <Box sx={{ display: "flex", gap: 2 }}>
                        <TextField
                          label={t("state_province")}
                          variant="outlined"
                          fullWidth
                          name="stateProvince"
                          value={businessInfo.stateProvince}
                          onChange={handleBusinessInfoChange}
                          error={Boolean(businessFormErrors.stateProvince)}
                          helperText={businessFormErrors.stateProvince}
                          required
                          size="small"
                          InputProps={{
                            sx: {
                              borderRadius: "8px",
                              height: "44px",
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#1976D2",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "#1976D2",
                                borderWidth: "2px",
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: "14px",
                              lineHeight: "25px",
                            },
                          }}
                        />
                        <TextField
                          label={t("country")}
                          variant="outlined"
                          fullWidth
                          name="country"
                          value={businessInfo.country}
                          onChange={handleBusinessInfoChange}
                          error={Boolean(businessFormErrors.country)}
                          helperText={businessFormErrors.country}
                          required
                          size="small"
                          InputProps={{
                            sx: {
                              borderRadius: "8px",
                              height: "44px",
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#1976D2",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "#1976D2",
                                borderWidth: "2px",
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: "14px",
                              lineHeight: "25px",
                            },
                          }}
                        />
                      </Box>

                      <Box sx={{ display: "flex", gap: 2 }}>
                        <TextField
                          label={t("zipcode")}
                          variant="outlined"
                          fullWidth
                          name="zipCode"
                          value={businessInfo.zipCode}
                          onChange={handleBusinessInfoChange}
                          error={Boolean(businessFormErrors.zipCode)}
                          helperText={businessFormErrors.zipCode}
                          required
                          size="small"
                          InputProps={{
                            sx: {
                              borderRadius: "8px",
                              height: "44px",
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#1976D2",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "#1976D2",
                                borderWidth: "2px",
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: "14px",
                              lineHeight: "25px",
                            },
                          }}
                        />
                        <TextField
                          label={t("no_of_locations")}
                          variant="outlined"
                          fullWidth
                          name="noOfLocations"
                          value={businessInfo.noOfLocations}
                          onChange={handleBusinessInfoChange}
                          required
                          disabled
                          size="small"
                          type="number"
                          InputProps={{
                            sx: {
                              borderRadius: "8px",
                              height: "44px",
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#1976D2",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                borderColor: "#1976D2",
                                borderWidth: "2px",
                              },
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: "14px",
                              lineHeight: "25px",
                            },
                          }}
                        />
                      </Box>
                      <Stack direction="row" alignItems="flex-start">
                        <Checkbox
                          required
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                          size="small"
                          sx={{ padding: "0px", marginRight: "5px" }}
                        />
                        <Typography
                          variant="caption"
                          sx={{ lineHeight: 1.5, fontSize: "13px" }}
                        >
                          By proceeding, I hereby confirm that I have reviewed
                          and accept the{" "}
                          <Link
                            href="#"
                            target="_blank"
                            rel="noopener"
                            onClick={(e) => {
                              e.preventDefault();
                              handleopenterms("terms");
                            }}
                          >
                            Terms & Conditions
                          </Link>{" "}
                          and{" "}
                          <Link
                            href="/privacy"
                            onClick={(e) => {
                              e.preventDefault();
                              handleopenterms("privacy");
                            }}
                          >
                            Privacy Policy
                          </Link>{" "}
                          and all applicable policies.
                        </Typography>
                      </Stack>
                    </Box>
                    <Box>
                      <Grid
                        container
                        direction={{ xs: "column-reverse", md: "row" }}
                        sx={{ mt: 6 }}
                      >
                        <Grid
                          item
                          xs={12}
                          md={6}
                          sx={{
                            textAlign: "left",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            component="a"
                            onClick={() => {
                              navigate("/");
                            }}
                            sx={{
                              mt: { xs: 2, sm: 0, md: 0 },
                              textDecoration: "underline",
                              color: "primary.main",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              "&:hover": {
                                color: "#000",
                              },
                            }}
                          >
                            <KeyboardDoubleArrowLeftIcon sx={{ mr: 0.5 }} />
                            Back to Login
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          sx={{
                            textAlign: "left",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Button
                            variant="contained"
                            sx={{
                              width: { xs: "100%", sm: "160px" },
                              borderRadius: "10px",
                              textTransform: "none",
                              py: 1.5,
                              fontSize: "1rem",
                            }}
                            disabled={!isChecked}
                            onClick={handleSubmit}
                          >
                            {t("proceed")}
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Dialog
          open={successOpen}
          onClose={handleSuccessClose}
          PaperProps={{
            sx: {
              backgroundColor: "#f0f9ff", // Light blue background
              borderRadius: 4,
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              padding: 2,
              textAlign: "center",
            },
          }}
        >
          <Box display="flex" flexDirection="column" alignItems="center" p={2}>
            <CheckCircleIcon sx={{ fontSize: 50, color: "#4CAF50", mb: 1 }} />
            <DialogTitle sx={{ fontWeight: "bold", color: "#333" }}>
              {t("success")}
            </DialogTitle>
            <DialogContent>
              <Typography variant="body1" color="text.secondary">
                {t("free_trial_thank_you_request")}
              </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
              <Button
                onClick={handleSuccessClose}
                variant="contained"
                sx={{
                  backgroundColor: "#4CAF50",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#388E3C" },
                }}
              >
                OK
              </Button>
            </DialogActions>
          </Box>
        </Dialog>
        <TermsandConditions
          open={openterms}
          handleCloseTerms={handlecloseterms}
          title={modalTitle}
          type={modalType} // 🔹 Pass 'type' prop (required in API fetch)
        />
      </Box>
    </>
  );
};

export default Signup;
